"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceResponseToJSON = exports.AudienceResponseFromJSONTyped = exports.AudienceResponseFromJSON = exports.instanceOfAudienceResponse = void 0;
var runtime_1 = require("../runtime");
var AudienceSizeRange_1 = require("./AudienceSizeRange");
var AudienceStatus_1 = require("./AudienceStatus");
var AudienceType_1 = require("./AudienceType");
/**
 * Check if a given object implements the AudienceResponse interface.
 */
function instanceOfAudienceResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceResponse = instanceOfAudienceResponse;
function AudienceResponseFromJSON(json) {
    return AudienceResponseFromJSONTyped(json, false);
}
exports.AudienceResponseFromJSON = AudienceResponseFromJSON;
function AudienceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, AudienceType_1.AudienceTypeFromJSON)(json['type']),
        'size': !(0, runtime_1.exists)(json, 'size') ? undefined : (0, AudienceSizeRange_1.AudienceSizeRangeFromJSON)(json['size']),
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AudienceStatus_1.AudienceStatusFromJSON)(json['status']),
        'seedAudienceId': !(0, runtime_1.exists)(json, 'seed_audience_id') ? undefined : json['seed_audience_id'],
        'lookalikeAudienceIds': !(0, runtime_1.exists)(json, 'lookalike_audience_ids') ? undefined : json['lookalike_audience_ids'],
    };
}
exports.AudienceResponseFromJSONTyped = AudienceResponseFromJSONTyped;
function AudienceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'type': (0, AudienceType_1.AudienceTypeToJSON)(value.type),
        'size': (0, AudienceSizeRange_1.AudienceSizeRangeToJSON)(value.size),
        'status': (0, AudienceStatus_1.AudienceStatusToJSON)(value.status),
        'seed_audience_id': value.seedAudienceId,
        'lookalike_audience_ids': value.lookalikeAudienceIds,
    };
}
exports.AudienceResponseToJSON = AudienceResponseToJSON;
